import React from 'react';
import classes from "./DrawerToggle.css";
import ToggleDash from "./ToggleDash/ToggleDash";

const DrawerToggle = (props) => {
    return (<div className={classes.Menu} onClick={props.clicked}><ToggleDash /><ToggleDash /><ToggleDash /></div>);
}

export default DrawerToggle;